import { getUserId } from '../helpers/get-user-id.helpers'

export const gfCreateTransactionId = () => {
  const userId = getUserId()
  return userId + Date.now()
}
